import React, { Suspense } from 'react';

import {
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import { useAuthContext } from "../Contexts/AuthProvider";

import { createTheme, ThemeProvider } from '@mui/material/styles';

import Header from "./ChannelHeader";
import { Box } from '@mui/material';
import styles from '../Channel/Channels.module.css';

const PreviewPage = React.lazy(() => import("../Channel/Preview"));
const ProfilePage = React.lazy(() => import("../Profile/ProfilePage"));
const PodcastHistoryPage = React.lazy(() => import("../Channel/History"));
const ChannelsPage = React.lazy(() => import("../Channel/Channels"));
const ChannelViewPage = React.lazy(() => import("../Channel/ChannelView"));

const LoginPage = React.lazy(() => import("../Login/LoginTailwind"));
const SignupPage = React.lazy(() => import("../Login/SignupTailwind"));

const AboutPage = React.lazy(() => import("../Misc/About"));
const GuidePage = React.lazy(() => import("../Misc/Guide"));
const ContactPage = React.lazy(() => import('../Misc/Contact'));
const FaqPage = React.lazy(() => import('../Misc/Faq'));
const MembershipPage = React.lazy(() => import('../Misc/Membership'));
const PaymentPage = React.lazy(() => import('../Misc/Subscription'));

const GuestLanding = React.lazy(() => import('../GuestLanding'));
const AzureSignIn = React.lazy(() => import('../Misc/Azure/SignIn'));
const AzureSignOut = React.lazy(() => import('../Misc/Azure/SignOut'));

export default function PodcastSite() {
  const { token } = useAuthContext();

  const theme = createTheme({
    palette: {
      mode: 'dark',
      button: {
        main: 'rgba(180, 180, 180, 1)'
      },
      modal: {
        main: 'rgba(50, 50, 50, 1)'
      },
      theme: {
        main: "#FF01CD",
      }
    }
  });

  const loggedIn = token !== null;

  const routesWithHeader = () => {
    return (
      <>
        <Route path="/guide" element={<GuidePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/membership" element={<MembershipPage />} />
        <Route path="/subscription" element={<PaymentPage />} />
        <Route path="/faq" element={<FaqPage />} />

        <Route path="/contact" element={<ContactPage />} />

        {!loggedIn &&
          <Route path="/" element={<Navigate to='/login' replace={true} />} />
        }

        {loggedIn &&
          <>
            <Route path="/" element={<ChannelsPage key='channel' />} />
            <Route path="/favourites" element={<ChannelsPage key='favorite' />} />
            <Route path="/classes" element={<ChannelsPage key='class' />} />
          </>
        }
        <Route path="/channel/:channelId" element={<ChannelViewPage />} />

        <Route path="/history" element={loggedIn ? <PodcastHistoryPage /> : <GuestLanding pageContext="podcasts" />} />
      </>
    );
  }

  const routesWithoutHeader = () => {
    return (
      <>
        <Route path="/members/:handle" element={<ProfilePage />} />
        <Route path="/profile/:userId" element={<ProfilePage />} />
        <Route path="/podcast-ep/:linkId" element={<PreviewPage />} />

        <Route path="/login" element={loggedIn ? <Navigate to="/" replace={true} /> : <LoginPage mode='login' />} />,
        <Route path="/register" element={loggedIn ? <Navigate to="/" replace={true} /> : <SignupPage mode='signup' />} />,

        <Route path="/auth/ms/login" element={<AzureSignIn />} />
        <Route path="/auth/ms/logout" element={<AzureSignOut />} />
      </>
    );
  }

  const overlayRoutes = () => {
    if (loggedIn) {
      return (
        <>
          <Route path="/login" element={<Navigate to="/" replace={true} />} />,
          <Route path="/register" element={<Navigate to="/" replace={true} />} />,
          <Route path="/resetpassword" element={<Navigate to="/" replace={true} />} />
        </>
      );
    }
    return (
      <>
      </>
    );
  }

  if (true) {
    return (
      <ThemeProvider theme={theme}>
        <div
          style={{
            position: 'absolute', top: '0px', left: '0px', right: '0px',
            minHeight: '100dvh',
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
          }}>
          <Suspense fallback={<div />}>
            <Routes>
              {routesWithoutHeader()}
              <Route path="*" element={
                <>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                      height: '100%'
                    }}>
                    <Header />

                    <Box sx={{ minHeight: { 'xs': 'calc(100dvh - 72px - 78px)', 'md': 'calc(100dvh - 72px - 78px)' } }}>
                      <Suspense fallback={<div />}>
                        <Routes>
                          {routesWithHeader()}
                        </Routes>
                      </Suspense>
                    </Box>

                    <footer className={styles["footer"]}>
                      <div className={styles["footer-inner"]}>
                        <div>© 2026 Vactors</div>
                        <div className={styles["footer-links"]}>
                          <a target="_blank" href="https://www.vactors.club/About">About Us</a>
                          <a target="_blank" href="https://www.vactors.club/Contact">Contact Us</a>
                          <a target="_blank" href="https://www.vactors.club/terms">Terms of Use</a>
                          <a target="_blank" href="https://www.vactors.club/privacy">Privacy Policy</a>
                        </div>
                      </div>
                    </footer>
                  </Box>

                  <Suspense fallback={<div />}>
                    <Routes>
                      {overlayRoutes()}
                    </Routes>
                  </Suspense>
                </>
              } />
            </Routes>
          </Suspense>

        </div>
      </ThemeProvider>
    )
  }
}